import { Box } from "@mui/material"
import type React from "react"
import { MainContent } from "../../MainContent"
import { usePrecomputedBiothreatSignals } from "../PrecomputedBiothreatSignalsContext"
import { PrecomputedSelectedSignals } from "../PrecomputedSelectedSignals"
import { BiothreatV2CommandBar } from "./BiothreatV2CommandBar"
import { BiothreatV2GdeltView } from "./BiothreatV2GdeltView"
import { BiothreatV2NwssView } from "./BiothreatV2NwssView"
import { V2_SURFACE } from "./biothreatV2Tokens"

/**
 * "Command console" layout for the Biothreat Signals page — the page's sole
 * layout, mounted by AlertCurationGated inside PrecomputedBiothreatSignalsProvider.
 * Each tab is its own view so the per-source data hooks are never called
 * conditionally.
 */
export const BiothreatV2Page: React.FC = () => {
  const { activeTab } = usePrecomputedBiothreatSignals()

  return (
    <MainContent
      headerProps={{ title: "Biothreat Signals" }}
      disableHorizontalGutters
      disableLeftGutter
    >
      {/* Full-bleed console — fills the entire content area, no inset container. */}
      <Box
        sx={{
          backgroundColor: V2_SURFACE.app,
          minHeight: "calc(100vh - 64px)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <BiothreatV2CommandBar />
        {/* Pinned signals live inside the console. */}
        <Box sx={{ px: 3, pt: 3 }}>
          <PrecomputedSelectedSignals variant="command" />
        </Box>
        {activeTab === "gdelt" ? (
          <BiothreatV2GdeltView />
        ) : (
          <BiothreatV2NwssView />
        )}
      </Box>
    </MainContent>
  )
}
